import { useSubscription } from '@apollo/client';
import { CACHE_CONFIGURATIONS_RESET } from '../../settings/subscriptions';
import { INSURANCE_DATA_QUERY } from '../../insuranceDocument/queries/insuranceDocumentQueries';
import { PARTNER_QUERY } from '../../insuranceDocument/edit/general/partner/queries';
import { PARTNERS_UPDATED } from '../../insuranceDocument/edit/general/partner/subscriptions';
import { PARTNERS_CHANGED } from '../../insuranceDocument/subscriptions/insuranceDocumentSubscriptions';
import { INSURANCE_CONVENTIONS_INVALIDATED } from '../../insuranceDocument/edit/offer/casco/subscriptions';
import { SERVER_COMPONENT_RESET } from 'features/insuranceDocument/edit/root/subscriptions';
import { useApolloClient } from '@apollo/client';
import { resetCache } from 'utils/cache/resetCache';
import { invalidateAllCascoQuotations } from '../../insuranceDocument/edit/offer/casco/quotationsUtils';
import { useToast } from 'hooks';
import { useTranslation } from 'react-i18next';

const GlobalSubscriptionArea = () => {
  const client = useApolloClient();
  const addToast = useToast();
  const { t } = useTranslation();

  /*All clients must invalidate the cache.*/
  useSubscription(CACHE_CONFIGURATIONS_RESET, {
    onData: ({ client }) => {
      resetCache(client);
    }
  });

  useSubscription(PARTNERS_UPDATED, {
    onData: ({ client, data: { data } }) => {
      const __typename = 'Partner';
      const { partners } = data.partnersUpdated;
      if (partners === null) return;

      partners.forEach(partner => {
        const normalizedId = client.cache.identify({ partnerId: partner.partnerId, __typename });

        if (normalizedId != null) {
          client.writeQuery({
            query: PARTNER_QUERY,
            data: {
              partner: {
                __typename,
                ...partner
              }
            }
          });
          client.cache.gc();
        }
      });
    }
  });

  useSubscription(PARTNERS_CHANGED, {
    onData: ({
      data: {
        data: { partnersChanged }
      }
    }) => {
      if (!partnersChanged) return;
      const data = client.readQuery({
        query: INSURANCE_DATA_QUERY,
        variables: { documentId: partnersChanged.documentId }
      });
      if (!data || !data?.insuranceData) return;

      client.cache.writeQuery({
        query: INSURANCE_DATA_QUERY,
        data: {
          insuranceData: {
            ...data.insuranceData,
            insuredId: partnersChanged.insuredId,
            clientId: partnersChanged.clientId
          }
        },
        variables: {
          documentId: partnersChanged.documentId
        }
      });
      client.cache.gc();
    }
  });

  useSubscription(INSURANCE_CONVENTIONS_INVALIDATED, {
    onData: _ => {
      invalidateAllCascoQuotations(client);
    }
  });

  useSubscription(SERVER_COMPONENT_RESET, {
    onData: _ => {
      addToast(t('General.ServerComponentReset'), 'info', { toastId: 'serverComponentResetToast' }, null, false, true);
    }
  });

  return '';
};

export default GlobalSubscriptionArea;
